import { lightTheme, ThemeProvider } from '@medely/web-components/themes';
import AppRouter from 'AppRouter';
import { ReactQueryProvider } from 'context/reactQueryContext';
import React, { ReactNode, useEffect } from 'react';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import './styles/global.css';
import config from '@mp/config';
import { StripeProvider } from '@medely/web-components/contexts';
import { FeatureGateProvider } from 'context/featureGateContext';
import GraphQLPermissionsContextProvider, {
  useGraphQLPermissionsContext,
} from 'context/graphqlContext';
import { useFirebaseContext } from '@medely/ui-kit/web';
import CenteredLoader from 'components/CenteredLoader';
import { gateNames, PageTitleProvider, ProNavigateProvider, useGate, WebViewProvider } from '@mp';
import { useAnalytics } from '@medely/ui-kit';
import { GeoLocationProvider } from '@mp/contexts/GeoLocationContext';

const App = () => {
  return (
    <WebViewProvider>
      <ReactQueryProvider>
        <FeatureGateProvider>
          <GraphQLPermissionsContextProvider>
            <ThemeProvider theme={lightTheme}>
              <StripeProvider stripeKey={config.stripePublishableKey!}>
                <PageTitleProvider>
                  <ProNavigateProvider>
                    <GeoLocationProvider>
                      <LoadingBox>
                        <AppRouter />
                      </LoadingBox>
                    </GeoLocationProvider>
                  </ProNavigateProvider>
                </PageTitleProvider>
              </StripeProvider>
            </ThemeProvider>
          </GraphQLPermissionsContextProvider>
        </FeatureGateProvider>
      </ReactQueryProvider>
    </WebViewProvider>
  );
};

const LoadingBox = ({ children }: { children: ReactNode }) => {
  const { loading: isLoadingFirebase } = useFirebaseContext();
  const disableSegmentIntercomEvents = useGate(gateNames.disableSegmentIntercomEvents);
  const { isLoading: isLoadingGraphQLPermissions } = useGraphQLPermissionsContext();

  const isLoading = isLoadingFirebase || isLoadingGraphQLPermissions;

  const analytics = useAnalytics();

  useEffect(() => {
    analytics.setDefaultProperties({
      integrations: { Intercom: disableSegmentIntercomEvents ? false : true },
    });
  }, []);

  if (isLoading) {
    return <CenteredLoader />;
  }

  return <>{children}</>;
};

export default App;
